var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2496 0.758431C10.9246 0.433431 10.3996 0.433431 10.0746 0.758431L5.99961 4.8251L1.92461 0.750098C1.59961 0.425098 1.07461 0.425098 0.749609 0.750098C0.424609 1.0751 0.424609 1.6001 0.749609 1.9251L4.82461 6.0001L0.749609 10.0751C0.424609 10.4001 0.424609 10.9251 0.749609 11.2501C1.07461 11.5751 1.59961 11.5751 1.92461 11.2501L5.99961 7.1751L10.0746 11.2501C10.3996 11.5751 10.9246 11.5751 11.2496 11.2501C11.5746 10.9251 11.5746 10.4001 11.2496 10.0751L7.17461 6.0001L11.2496 1.9251C11.5663 1.60843 11.5663 1.0751 11.2496 0.758431Z",
    fill: "#212C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerClose);
export default __webpack_public_path__ + "static/media/banner-close.2ef2ffefbe33147f606cb47cc425e0dc.svg";
export { ForwardRef as ReactComponent };